<nav class="bottom-nav" aria-label="Primary navigation">
  <a
    class="bottom-nav__item"
    routerLink="/home"
    routerLinkActive="bottom-nav__item--active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <span class="bottom-nav__icon-wrap">
      <svg class="bottom-nav__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </span>
    <span class="bottom-nav__label">Home</span>
  </a>

  <a
    class="bottom-nav__item"
    routerLink="/categories"
    routerLinkActive="bottom-nav__item--active"
  >
    <span class="bottom-nav__icon-wrap">
      <svg class="bottom-nav__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    </span>
    <span class="bottom-nav__label">Communities</span>
  </a>

  <a
    class="bottom-nav__item bottom-nav__item--center"
    routerLink="/ask"
    routerLinkActive="bottom-nav__item--active"
    aria-label="Create a post"
  >
    <span class="bottom-nav__fab" aria-hidden="true">
      <svg class="bottom-nav__fab-icon" viewBox="0 0 24 24" fill="none">
        <path d="M12 5v14M5 12h14"></path>
      </svg>
    </span>
  </a>

  <a
    class="bottom-nav__item"
    routerLink="/activity"
    routerLinkActive="bottom-nav__item--active"
  >
    <span class="bottom-nav__icon-wrap has-badge">
      <svg class="bottom-nav__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
      @if (unreadCount() > 0) {
        <span class="bottom-nav__badge">{{ unreadBadgeLabel() }}</span>
      }
    </span>
    <span class="bottom-nav__label">Activity</span>
  </a>

  <a
    class="bottom-nav__item"
    routerLink="/me"
    routerLinkActive="bottom-nav__item--active"
  >
    <span class="bottom-nav__icon-wrap">
      <svg class="bottom-nav__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </span>
    <span class="bottom-nav__label">Profile</span>
  </a>
</nav>
